import { render, staticRenderFns } from "./ExaminationIndex.vue?vue&type=template&id=32c82466&scoped=true"
import script from "./ExaminationIndex.vue?vue&type=script&lang=js"
export * from "./ExaminationIndex.vue?vue&type=script&lang=js"
import style0 from "./ExaminationIndex.vue?vue&type=style&index=0&id=32c82466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c82466",
  null
  
)

export default component.exports